module.exports = __webpack_public_path__ + "static/img/12.eec0274.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/eng/12.png
// module id = cmxp
// module chunks = 0